import apiClient from "./apiClient";

const buildForm = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return formData;
};

export const uploadRiskEvidenceFile = (riskId, file, config = {}) =>
  apiClient.post(`/risks/${riskId}/evidence`, buildForm(file), {
    headers: { "Content-Type": "multipart/form-data" },
    ...config,
  });

export const uploadControlEvidenceFile = (controlId, file, config = {}) =>
  apiClient.post(`/controls/${controlId}/evidence`, buildForm(file), {
    headers: { "Content-Type": "multipart/form-data" },
    ...config,
  });

export const uploadRiskEvidenceUrl = (riskId, url) =>
  apiClient.post(`/risks/${riskId}/evidence`, { url });

export const uploadControlEvidenceUrl = (controlId, url) =>
  apiClient.post(`/controls/${controlId}/evidence`, { url });

export const listRiskEvidence = (riskId, params = {}) =>
  apiClient.get(`/risks/${riskId}/evidence`, { params });

export const listControlEvidence = (controlId, params = {}) =>
  apiClient.get(`/controls/${controlId}/evidence`, { params });

export const deleteEvidence = (evidenceId) => apiClient.delete(`/evidence/${evidenceId}`);
export const restoreEvidence = (evidenceId) => apiClient.post(`/evidence/${evidenceId}/restore`);

export const searchExistingEvidence = (params = {}) => apiClient.get("/evidence/search", { params });
export const listEvidenceAssociations = (type, id) => apiClient.get(`/records/${type}/${id}/evidence-associations`);
export const linkExistingEvidence = (type, id, evidenceId) => apiClient.post(`/records/${type}/${id}/evidence-associations`, { evidence_id: evidenceId });
export const unlinkEvidence = (type, id, evidenceId) => apiClient.delete(`/records/${type}/${id}/evidence-associations/${evidenceId}`);
export const listEvidenceRecords = (evidenceId) => apiClient.get(`/evidence/${evidenceId}/associations`);

export const downloadEvidenceUrl = (evidenceId) => {
  const baseURL = apiClient.defaults.baseURL || "";
  const normalizedBase = baseURL.endsWith("/") ? baseURL.slice(0, -1) : baseURL;
  return `${normalizedBase}/evidence/${evidenceId}/file`;
};

